import ar from './ar.json'
import br from './br.json'
import cn from './cn.json'
import de_DE from './de-DE.json'
import en from './en.json'
import es from './es.json'
import fr_FR from './fr-FR.json'
import jp from './jp.json'
import kr from './kr.json'
import nl_NL from './nl-NL.json'
import ru from './ru.json'
import tr from './tr.json'
import uk_UA from './uk-UA.json'
import vn from './vn.json'
import zh_TW from './zh-TW.json'

export default {
  ar,
  br,
  cn,
  'de-DE': de_DE,
  en,
  es,
  'fr-FR': fr_FR,
  jp,
  kr,
  'nl-NL': nl_NL,
  ru,
  tr,
  'uk-UA': uk_UA,
  vn,
  'zh-TW': zh_TW,
}